export default "__VITE_ASSET__B3PQdoW1__"